<template>
  <transition name="fade" mode="out-in">
    <div id="order-status-bar">
      <el-row :gutter="24" class="mt-10 mb-20">
        <el-col v-for="positionLevel in TRACKER_CONSTANTS.ORDER_STATUS_BAR_STEPS" :key="positionLevel" :span="6" class="display-grid">
          <div :class="getStatusBarClass(positionLevel)" class="grid-content" :style="`--background: ${progressColor};`">
            <span class="bar">
              <span class="progress" :style="`--background: ${progressColor};`" />
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
  </transition>
</template>
<script>
// Mixins
import TemplateMethods from '@/utils/mixins/stepsBarMethods'

const STATUS_BAR_CLASSES = {
  ACTIVE: 'progress-bar',
  DISABLED: 'bg-gray',
  COMPLETED: 'bg-green'
}

export default {
  name: 'OrderStatusBar',
  mixins: [TemplateMethods],
  data: () => ({
    STATUS_BAR_CLASSES
  })
}
</script>

